import ChatIcon from "@mui/icons-material/Chat";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../hooks";
import { useRouter } from "../../hooks/useRouter";
import { ROUTES } from "../../routes";
import { createClickEngagementRecorder } from "../../utils/api";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";

const DirectMessage = () => {
  const { t } = useTranslation();
  const { push, location } = useRouter();
  const { lastDMTarget } = useAppSelector((state) => state.dmState);
  const { roomDomain } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);

  const handleBtnClick = () => {
    clickRecorder("menu-dm");
    push({
      pathname: `${ROUTES.DM_PAGE}/${
        lastDMTarget?.toAddress && lastDMTarget.toAddress
      }`,
      ...(lastDMTarget?.toAddress && {
        search: `?alias=${lastDMTarget.alias}`,
      }),
    });
  };

  const isActive =
    location.pathname.includes(ROUTES.DM_PAGE) ||
    location.state?.from?.includes(ROUTES.DM_PAGE);

  return (
    <Tooltip
      title={t("SocialConnection_Direct_Messages")}
      placement="bottom"
      arrow
      disableInteractive
    >
      <IconButton
        aria-label="invite"
        onClick={handleBtnClick}
        color={isActive ? "primary" : "default"}
      >
        <ChatIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default DirectMessage;
